import { IFriendData, IPictureProgress, IUserBalance } from '../Services/CloudDB/Contract';
import { Inject } from '@denishussar/html5-game-engine';
import { FirebaseCloudDB } from '../Services/CloudDB/FirebaseCloudDB';

export class UserModel {
    public id: string = Math.random().toString(16).slice(2);
    public name: string;
    public balance: IUserBalance;
    public friends: IFriendData[];
    public albums: string[];
    public progress: IPictureProgress[];
    constructor(
        @Inject private _db: FirebaseCloudDB,
    ) {
        const data = this._db.getUserData()
        this.balance = data.balance;
        this.albums = data.albums;
        this.progress = data.progress;
    }
}
